import { roleModuleFilter } from "./constants";

export const validatePermission = (rolId, permission) => {
  if (!rolId || !permission) return false;
  const findRole = roleModuleFilter.find((role) => role.Rol === Number(rolId));
  if (!findRole) return false;
  if (findRole.Full) return true;
  if (!findRole.Filters) return false;
  return findRole.Filters.includes(permission);
};
